import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import './index.scss';

const PrimaryButtonGE = (props) => {
  const { text, onClick, filled = true, className = '', disabled = false } = props
  return (
    <PrimaryButton
      className={`primary-btn filled-${filled} ${className}`}
      text={text}
      onClick={onClick}
      disabled={disabled}
    />
  );
}

export default PrimaryButtonGE;